import { MessageInstance } from 'antd/es/message/interface';
import { HookAPI } from 'antd/es/modal/useModal';
import { Location, NavigateFunction } from 'react-router-dom';

export const routerUtils = {
  navigate: (() => {}) as NavigateFunction,
  location: {} as Location,
};

export const messageUtils = {
  message: {} as MessageInstance,
};

export const modalUtils = {
  modal: {} as HookAPI,
};
